import { fns, libTypes } from "@holta/lib";
import { feathersApp } from "../config/feathers";
import { createNewOrder, getMergedOrderFromStore } from "./editOrder";
import { user } from "../fns/user";
import toast from "react-hot-toast";

export const sendOrder = () => {

    try {

        toast.loading('Sending order...');
        const order = getMergedOrderFromStore();
    
        const customerConvertedOrder = {
            customerEmail: user.email,
            customerRef: order.customerRef,
            deliveryDate: order.deliveryDate,
            deliveryDateType: order.deliveryDateType,
            deliveryAddress: order.deliveryAddress,
            deliveryNotes: order.deliveryNotes,
            carcaseColour: order.carcaseColour,
            constructionType: order.constructionType,
            drawerbox: order.drawerbox,
            voidSize: order.voidSize,
            gluedWallUnits: order.gluedWallUnits,
            items: order.items.filter(fns.order_item.isCarcaseItem).map((item) => {
                return {
                    productId: item.productId,
                    quantity: item.quantity,
                    hEdited: item.hEdited,
                    wEdited: item.wEdited,
                    dEdited: item.dEdited,
                    handing: item.handing,
                    notes: item.notes,
                };
            }),
        };
    
        return feathersApp.service("actions").create({
            action: "CUSTOMER_SEND_KITCHEN_ORDER",
            order: customerConvertedOrder}).then(() => {
                createNewOrder();
                toast.success('Order sent!');
                toast.dismiss();
                alert('Order sent!');
            });
    } catch (error) {
        toast.error('Error sending order');
        toast.dismiss();
        return error;
    }
  
};
